import store from "@/store";
import { ModifierType } from "./userModifierEnum";

export default function isModifierSet(modifier: ModifierType, modifierValue?: number) {
  const currentModifier = modifierValue ?? store.getters["login/getModifier"];
  return (currentModifier & modifier) !== 0;
}

interface SetModifierOptions {
  modifierValue?: number;
  updateStore?: boolean;
}

export function setModifier(
  modifier: ModifierType,
  isSet: boolean,
  { modifierValue, updateStore = false }: SetModifierOptions = {},
): number {
  const currentModifier = modifierValue ?? store.getters["login/getModifier"] ?? 0;
  const updatedModifier = isSet ? currentModifier | modifier : currentModifier & ~modifier;

  if (updateStore) {
    store.commit("login/updateModifier", updatedModifier);
  }

  return updatedModifier;
}
